import styled from 'styled-components'

const StyledAdminIssueHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  width: 100%;
  position: sticky;
  top: 70px;
  border-bottom: ${({ theme }) => theme.colors.gray[200]} 1px solid;
  height: 70px;
  display: flex;
  z-index: ${({ theme }) => theme.elevations.sticky};

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 1rem;
  }

  p {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    top: 0;
  }
`

export default StyledAdminIssueHeader
